const DeleteModal = ({ onCancel, onDelete }) => {
  return (
    <section className="bg-[#F5F5F5] rounded-2xl py-10 px-8 flex flex-col gap-6">
      <div className="flex flex-col gap-2 text-center">
        <h1 className="font-semibold text-base">Delete file?</h1>
        <p className="text-[13px] font-normal leading-[19px]">
          Are you sure you want to delete this file?
        </p>
      </div>

      <div className="flex gap-4 justify-center items-center">
        <button
          className="rounded-xl border-[1.5px] border-[#CD2224] hover:border-0 hover:bg-black hover:text-white py-3 px-5"
          onClick={onCancel}
        >
          Cancel
        </button>

        <button
          className="rounded-xl bg-[#CD2224] text-white hover:bg-black py-3 px-5"
          onClick={onDelete}
        >
          Delete
        </button>
      </div>
    </section>
  );
};

export default DeleteModal;
